module.exports = __webpack_public_path__ + "6e7127c9c4c624666b60d86af1d4cc95.pdf";